define([
    "underscore",
    "backbone",
    "forms/withdrawal/common_form"
], function(_, Backbone, CommonForm) {
    return CommonForm.extend({
        url: "/rest_withdrawal/validate_pm_form",

        validation: _.extend(CommonForm.prototype.validation, {
            e_wallet_id: {
                required: true
            }
        }),

        labels: _.extend(CommonForm.prototype.labels, {
            e_wallet_id: 'Perfect Money ID'
        })
    });
});
